import { graphql } from '@/generated/gql';

export const GET_SAVING_QUERY = graphql(/* GraphQL */ `
  query GetSaving($id: ID!) {
    saving(id: $id) {
      id
      name
      description
      status
      savingType
      currency
      baselinePrice
      newPrice
      baselineQuantity
      newQuantity
      validFrom
      validTo
      createdAt
      updatedAt
      fkBuyer
      fkSupplier
      fkCommodityGroup
      freeTextCommodity
      fkProcurementOrganization
      fkOrganization
      fkPurchasingGroup
      fkAccountingArea
      fkUnit
      originalPriceQuantity
      newPriceQuantity
      reductionType
      costAllocation {
        distributionType
        allocationValue
        fkAccountAssignmentCategory
        fkAccountAssignment
        fkGeneralLedgerAccount
      }
      sourceReferences {
        fkSourceSystem
        isPrimary
        sourceContext
        sourceReference
        sourceReferenceItem
        synchronizedAt
      }
    }
  }
`);
